import { gql } from '@apollo/client'

export const GET_TERRITORY_SUGGESTION = gql`
  query getUnifiedTerritoriesSuggestion($term: String!) {
    getSuggest(term: $term) {
      savedPostSearches(limit: 5) {
        territoryId
        name
      }
      subtopics(limit: 5) {
        territoryId
        title
        language
        topic {
          title
        }
      }
      topics(limit: 5) {
        title
        createdAt
        language
        territoryId
        category {
          title
        }
      }
    }
  }
`
